import axios from "axios";

// Use current origin when deployed on production domains; fallback to env var in preview/dev.
const PROD_HOSTS = new Set(["stavbos.cz", "www.stavbos.cz"]);
const BACKEND_URL =
  typeof window !== "undefined" && PROD_HOSTS.has(window.location.hostname)
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Něco se pokazilo. Zkus to prosím znovu.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function apiError(e) {
  return formatApiErrorDetail(e?.response?.data?.detail) || e?.message || "Chyba";
}

export const buildWsUrl = (path, token) => {
  const wsProtocol = BACKEND_URL.startsWith("https") ? "wss" : "ws";
  const host = BACKEND_URL.replace(/^https?:\/\//, "");
  const search = token ? `?token=${encodeURIComponent(token)}` : "";
  return `${wsProtocol}://${host}/api${path}${search}`;
};

export default api;
